module.exports = __webpack_public_path__ + "img/ysp.4c709454.png";